import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, Button, Stack, CircularProgress } from '@mui/material';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { useDispatch, useSelector } from 'react-redux';
import { checkShopifyConnection } from '../../../redux/actions/shopifyActions';
import useCallOnce from '../../../hooks/useCallOnce';
import ShopifyDialog from '../../ecommerce/ShopifyDialog';
import shopifyicon from '../../../images/shopify.png';
import { getUserById } from '../../../redux/actions/userActions';

function ShopifyIntegration({selectedUserId, selectedUser}) {
  const dispatch = useDispatch();
  const { loading, isConnected, stores } = useSelector((s) => s.shopify);
  const { byId: userById } = useSelector((s) => s.users);
  const userLoading = Boolean(userById?.loading);
  const [open, setOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);

  // Parent Integration fetches user; avoid duplicate calls here

  const handleConnectClick = () => {
      const shopifyAdminUrl = `https://apps.shopify.com/shop-agent`;
      window.open(shopifyAdminUrl, '_blank');
  };

  const fallbackSelectedPayload = userById?.data?.data || userById?.data;
  const fallbackSelected = fallbackSelectedPayload?.user || fallbackSelectedPayload;
  const shopifyFromUser = (selectedUser || fallbackSelected)?.shopify;
  const isConnectedFromUser = Boolean(shopifyFromUser?.storeUrl);

  return (
    <>
      <Card
        elevation={2}
        sx={{
          borderRadius: 2,
          bgcolor: '#ffffff',
          border: '1px solid #e5e7eb',
          height: '100%',
          minHeight: 350,
          cursor: isConnectedFromUser ? 'default' : 'pointer',
          '&:hover': !isConnectedFromUser ? { boxShadow: 4, borderColor: '#6b7280' } : {},
          transition: 'all 0.2s ease-in-out',
        }}
        onClick={!isConnectedFromUser ? () => 
          // setOpen(true) 
          handleConnectClick()
          : 
          undefined}
      >
        <CardContent sx={{ p: 4, textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box>
            <Box sx={{ width: 64, height: 64, borderRadius: '50%', bgcolor: isConnected ? '#f0fdf4' : '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 3,  }}>
              {/* <ShoppingBagIcon sx={{ fontSize: 32, color: isConnected ? '#16a34a' : '#6b7280' }} /> */}
              <img src={shopifyicon} alt="Shopify" style={{ width: 64, height: 64 }} />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: isConnectedFromUser ? '#16a34a' : '#111827' }}>
              Shopify
            </Typography>
          </Box>

          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            {userLoading ? (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                <CircularProgress size={22} />
              </Box>
            ) : isConnectedFromUser ? (
              <>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, bgcolor: '#f0fdf4', borderRadius: 2, border: '2px solid #bbf7d0' }}>
                  <Typography variant="body2" sx={{ color: '#15803d', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Connected
                  </Typography>
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                  <Button variant="text" size="small" onClick={() => setDetailsOpen(true)} sx={{ color: '#6b7280', '&:hover': { backgroundColor: '#f3f4f6' }}}>View Connection Details</Button>
                </Box>
                <Box sx={{ visibility: 'hidden', mt: 1, display: 'flex', justifyContent: 'center' }}>
                  <Button variant="text" size="small" sx={{ color: '#ffffff', backgroundColor: '#d32f2f', '&:hover': { backgroundColor: '#d32f2f' }}}>Disconnect</Button>
                </Box>
              </>
            ) : (
              <>
                <Typography variant="body2" sx={{ mb: 2, color: '#6b7280' }}>
                  Connect your Shopify store using your store URL, private app access token, and app secret key.
                </Typography>
                <Typography variant="body2" sx={{ color: '#6b7280' }}>
                  Click to configure Shopify integration settings
                </Typography>
              </>
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Connect / Configure Dialog */}
      <ShopifyDialog
        open={open}
        onClose={() => setOpen(false)}
        onConnect={() => setOpen(false)}
        readOnly={false}
        initialValues={null}
      />

      {/* View Details Dialog */}
      <ShopifyDialog
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        onConnect={() => setDetailsOpen(false)}
        readOnly={true}
        initialValues={shopifyFromUser || (isConnected && stores?.length > 0 ? stores[0] : null)}
      />
    </>
  );
}

export default ShopifyIntegration;


